import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/download-new.svg'


const _hoisted_1 = { class: "w-full my-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4 mb-8 text-14px text-black-lp-300"
}
const _hoisted_3 = { class: "space-y-3" }
const _hoisted_4 = { class: "text-red-lp-100 text-12px xxl:text-14px mb-4" }
const _hoisted_5 = { class: "w-1/2 grid grid-cols-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "mt-2 text-12px" }, " Download template dibawah untuk berkas lampiran harga khusus yang akan diunggah. ", -1)
const _hoisted_7 = { class: "whitespace-no-wrap text-red-lp-100 text-12px" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "w-4",
  src: _imports_0,
  alt: "download"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-12px text-gray-lp-500 w-8/12" }, " Harga akan berlaku sesuai dengan tanggal periode yang dipilih. Harga client mencakup Basic Rates & Custom Rates. ", -1)
const _hoisted_12 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_13 = { class: "text-red-lp-100 text-12px xxl:text-14px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_CardSelector = _resolveComponent("CardSelector")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_ModalForm = _resolveComponent("ModalForm")!

  return _withDirectives((_openBlock(), _createBlock(_component_ModalForm, {
    "is-background-footer": true,
    isDisabled: !_ctx.isFormValid,
    onClose: () => _ctx.$emit('close', false),
    onSubmit: !_ctx.isFormValid ? null : _ctx.onSubmit,
    title: _ctx.title,
    "modal-width": "w-6/12"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_Title, {
        label: "Pilihan Harga",
        class: "my-4"
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_CardSelector, {
          modelValue: _ctx.modelValue.isCustomRate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.isCustomRate = $event)),
          options: _ctx.customPriceOption,
          onInput: _ctx.onSelectRatesType,
          "disabled-key": _ctx.isUpdateRates ? 'value' : undefined,
          "disabled-value": _ctx.isUpdateRates ? _ctx.modelValue.isCustomRate : undefined
        }, null, 8, ["modelValue", "options", "onInput", "disabled-key", "disabled-value"])
      ]),
      (_ctx.isUpdateRates && _ctx.isMixRateBool)
        ? (_openBlock(), _createBlock("p", _hoisted_2, " *Di Harga Kombinasi anda dapat memperbaharui salah satu atau kedua harga sekaligus "))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", _hoisted_3, [
        (_ctx.isUpdateRates)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: "Versi Harga Normal",
              value: _ctx.modelValue.versionBasic,
              customStyleValue: "mt-3 mb-6",
              class: "w-full"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (!_ctx.isUpdateRates)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              label: "Versi Harga Normal",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  class: `${_ctx.errorVersionBasic ? `border-error my-1 mb-0` : 'my-1'}`,
                  onFilter: _ctx.fetchVersionRates,
                  onFocus: _ctx.fetchVersionRates,
                  onClose: _ctx.resetVersionRates,
                  isLoading: _ctx.loadingVersionRates,
                  options: _ctx.versionRates,
                  keyName: "rateVersionName",
                  keyValue: "rateVersionName",
                  placeholder: "Ketik atau pilih versi harga basic",
                  modelValue: _ctx.modelValue.versionBasic,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.versionBasic = $event)),
                  key: _ctx.resetSelectSearch,
                  isDisabled: _ctx.isUpdateRates
                }, null, 8, ["class", "onFilter", "onFocus", "onClose", "isLoading", "options", "modelValue", "isDisabled"]),
                _withDirectives(_createVNode("div", _hoisted_4, " Version Basic tidak bisa digunakan ", 512), [
                  [_vShow, _ctx.errorVersionBasic]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          (_ctx.isUpdateRates)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: "Diskon Saat Ini",
                value: `${_ctx.modelValue.currentDiscount}%`,
                customStyleValue: "mt-6",
                tooltipDescription: "Diskon hanya dapat dibuat dengan nilai 0-30%. Diskon dengan nilai 21-30% akan melalui proses approval dari manager."
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            label: `Diskon ${_ctx.isUpdateRates ? 'Baru' : ''}`,
            tooltipDescription: "Diskon hanya dapat dibuat dengan nilai 0-30%. Diskon dengan nilai 21-30% akan melalui proses approval dari manager."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                format: _ctx.formatFloat,
                modelValue: _ctx.modelValue.discount,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.discount = $event)),
                error: _ctx.error.discount,
                onChange: _ctx.validateDiscount,
                errorCaption: "Diskon tidak boleh lebih dari 30%",
                placeholder: "e.g 20",
                min: "0",
                max: "30",
                hint: "Masukan 0 bila tidak ada diskon",
                suffix: "%"
              }, null, 8, ["format", "modelValue", "error", "onChange"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ], 512), [
        [_vShow, _ctx.isBasicRateBool || _ctx.isMixRateBool]
      ]),
      (_ctx.isAbleUpload || _ctx.isUpdateRates)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: ["space-y-3", `${_ctx.isMixRateBool ? 'pt-6' : ''}`]
          }, [
            (!_ctx.isBasicRateBool)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_DataWrapper, {
                    label: "Template Harga Khusus",
                    class: "w-full py-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode("div", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.download(_ctx.templateFileLink, _ctx.templateFileName))),
                        class: "flex mt-1 items-center w-full gap-x-3 cursor-pointer"
                      }, [
                        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.templateFile), 1),
                        _hoisted_8
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.isUpdateRates)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 0,
                        label: "Versi Harga Khusus",
                        value: _ctx.modelValue.versionName,
                        customStyleValue: "mt-3 mb-6",
                        class: "w-full"
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isUpdateRates)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 1,
                        label: "Versi Harga Khusus",
                        class: "w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LpInput, {
                            modelValue: _ctx.modelValue.versionName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.versionName = $event)),
                            placeholder: "Masukan nama versi harga khusus"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: "Berkas Lampiran",
              class: "w-full",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UploadFile, {
                  maxRows: 160000,
                  "is-clear": _ctx.modelValue.archiveFile === '',
                  "check-column": _ctx.columnToValidate,
                  type: "csv",
                  modelValue: _ctx.modelValue.archiveFile,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.archiveFile = $event))
                }, null, 8, ["is-clear", "check-column", "modelValue"])
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true),
      _hoisted_9,
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_Title, { label: "Periode Harga" }),
        _hoisted_11
      ]),
      _createVNode("div", {
        class: "flex gap-x-8 w-10/12",
        style: `${!_ctx.invalidDate && `padding-bottom: 2em`}`
      }, [
        _createVNode(_component_DataWrapper, {
          label: "Dimulai Dari",
          class: "w-6/12 mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode("div", {
              class: 
              ` mt-2 flex flex-col w-full ${_ctx.error.priceRateStartDate &&
                'border-error'}`
            
            }, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.renewalRateStart,
                onSelected: _ctx.inputDateStart,
                minDate: _ctx.minDateRenewalRateStart,
                class: "my-2",
                disabled: _ctx.isUpdateRates
              }, null, 8, ["modelValue", "onSelected", "minDate", "disabled"])
            ], 2),
            _withDirectives(_createVNode("div", _hoisted_12, " Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir ", 512), [
              [_vShow, _ctx.error.priceRateStartDate]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Sampai",
          class: "w-6/12 mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode("div", {
              class: 
              `mt-2 flex flex-col w-full ${_ctx.error.priceRateEndDate &&
                'border-error'}`
            
            }, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.renewalRateEnd,
                onSelected: _ctx.inputDateEnd,
                minDate: _ctx.minDateRenewalRateEnd,
                class: "my-2",
                disabled: _ctx.isUpdateRates
              }, null, 8, ["modelValue", "onSelected", "minDate", "disabled"])
            ], 2),
            _withDirectives(_createVNode("div", _hoisted_13, " Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai ", 512), [
              [_vShow, _ctx.error.priceRateEndDate]
            ])
          ]),
          _: 1
        })
      ], 4),
      (_ctx.isUpdateRates)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 2,
            label: "Tanggal Aktif Harga",
            class: "w-6/12 mb-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Pickers, {
                class: "mt-3",
                modelValue: _ctx.modelValue.rateActiveDate,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.rateActiveDate = $event)),
                minDate: new Date(new Date().setDate(new Date().getDate() + 1))
              }, null, 8, ["modelValue", "minDate"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isDisabled", "onClose", "onSubmit", "title"])), [
    [_vShow, _ctx.modalRenewRates]
  ])
}